import { useQuery } from '@apollo/client'
import { GetJobInformationDocument } from 'generated/resources/graphql'

interface InformationParams {
  roleIds: string[]
}

export const useJobPositionInformation = (variables: InformationParams) => {
  const { loading, data } = useQuery(GetJobInformationDocument, { variables })

  return {
    loading,
    data: {
      jobPostings: data?.ats.jobPostings || [],
      levels: data?.jobCatalog.levels || [],
      roles: data?.jobCatalog.roles || [],
    },
  }
}
